import { render, staticRenderFns } from "./CommunityUnitBusinessNewsUpdate.vue?vue&type=template&id=8be64b16&"
import script from "./CommunityUnitBusinessNewsUpdate.vue?vue&type=script&lang=js&"
export * from "./CommunityUnitBusinessNewsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUnitBusinessNewsUpdate.vue?vue&type=style&index=0&id=8be64b16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports